(function () {

    'use strict';

    angular.module('iplusjs.bloecke.upload', [
        'lodash',
        'iplusjs.fileupload'
    ])
        .component('iplusjsBlockUpload', {
            bindings: {
                fileTypes: '@ibuFileTypes',
                disabled: '<ibuDisabled',
                multiple: '@ibuMultiple',
                maxFileSize: '@ibuMaxFileSize',
                maxFileSizeAll: '@ibuMaxFileSizeAll',
                maxFileCount: '@ibuMaxFileCount',
                onUpload: '&ibuUpload',
                onShow: '&ibuShow',
                onDelete: '&ibuDelete',
                files: '<ibuFiles',
                options: '<ibuOptions'
            },
            transclude: {
                uploadTitle: '?uploadTitle',
                uploadHinweis: '?uploadHinweis'
            },
            templateUrl: 'common/bloecke/upload/blockUpload.html',
            controller: BlockUploadController,
            controllerAs: 'uploadVm'
        });

    BlockUploadController.$inject = [
        'lodash'
    ];
    function BlockUploadController(_) {
        var vm = this;

        vm.$onInit = onInit;
        vm.uploadFiles = uploadFiles;
        vm.deleteFile = deleteFile;
        vm.showFile = showFile;

        function activate() {}

        function onInit() {
            activate();
        }

        function uploadFiles(files) {
            vm.onUpload({
                files: files
            });
        }

        function deleteFile(file) {
            vm.onDelete({
                file: file
            });
        }

        function showFile(file) {
            vm.onShow({
                file: file
            });
        }
    }

})();
